/**
 * i18n keys of a built-in preview scenario's label and short description
 * (JUB-161). The fixture's `proves` text is an internal design note (English,
 * sometimes with ticket references), so the UI never shows it; the machine id
 * stays the option value and appears only as a muted reference line.
 */
export const scenarioLabelKey = (id: string) => `admin.templates.scenarios.${id}.label`;
export const scenarioDescriptionKey = (id: string) => `admin.templates.scenarios.${id}.description`;
